/* Layout */
import Layout from '@/layout'

export default {
  path: '/info',
  component: Layout,
  redirect: '/info/disease',
  name: 'info',
  meta: { title: '基础信息', icon: 'base-info' },
  children: [
    {
      path: 'disease',
      name: 'disease',
      component: () => import('@/views/info/disease/index'),
      meta: { title: '中医疾病', icon: 'disease' }
    },
    {
      path: 'syndrome',
      name: 'syndrome',
      component: () => import('@/views/info/syndrome/index'),
      meta: { title: '证候信息', icon: 'syndrome' }
    },
    {
      path: 'symptom',
      name: 'symptom',
      component: () => import('@/views/info/symptom/index'),
      meta: { title: '症状信息', icon: 'symptom' }
    },
    {
      path: 'book',
      name: 'book',
      component: () => import('@/views/info/book/index'),
      meta: { title: '书籍信息', icon: 'book' }
    },
    {
      path: 'disease-location',
      name: 'disease-location',
      component: () => import('@/views/info/disease-location/index'),
      meta: { title: '病位信息', icon: 'disease-location' }
    },
    {
      path: 'disease-nature',
      name: 'disease-nature',
      component: () => import('@/views/info/disease-nature/index'),
      meta: { title: '病性信息', icon: 'disease-nature' }
    },
    {
      path: 'therapy',
      name: 'therapy',
      component: () => import('@/views/info/therapy/index'),
      meta: { title: '治法信息', icon: 'therapy' }
    }
  ]
}
